import { isCatalogEmbedNodeType } from "@repo/shared";

/**
 * Inline atoms that carry meaning purely by existing, so a section containing only one
 * of them is never "empty". `atomicField` is deliberately absent: it is meaningful only
 * when its `value` is set, and each caller applies that check itself.
 */
const MEANINGFUL_ATOM_NODE_TYPES = new Set(["mention", "documentEvidence", "image"]);

export function isMeaningfulAtomNodeType(nodeType: string | undefined): boolean {
  return Boolean(
    nodeType && (MEANINGFUL_ATOM_NODE_TYPES.has(nodeType) || isCatalogEmbedNodeType(nodeType))
  );
}
